import useAsyncData from "../../../../../hooks/use-async-data";
import billingService from "../../../billings.service";
import BillingsOrderCargoRailyDraft from "./billings-order-cargo-raily-draft";
import BillingsOrderCargoRailyDraftParams from "./billings-order-cargo-raily-draft-params";

const useCargoRailyBillingDraft = () => {
  const { data, isError, isLoading, setData, setIsError, setIsLoading } =
    useAsyncData<BillingsOrderCargoRailyDraft | null>(null);

  const load = async (
    params: BillingsOrderCargoRailyDraftParams,
    abortSignal: AbortSignal,
  ): Promise<void> => {
    setIsError(false);
    setIsLoading(true);

    try {
      const data = await billingService.getOrderCargoRailyBillingsDraft(
        params,
        abortSignal,
      );

      setData(data);
    } catch {
      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    data,
    isError,
    isLoading,
    load,
  };
};

export default useCargoRailyBillingDraft;
